import { render, staticRenderFns } from "./QAsView.vue?vue&type=template&id=7ff3ea42&"
import script from "./QAsView.vue?vue&type=script&lang=js&"
export * from "./QAsView.vue?vue&type=script&lang=js&"
import style0 from "./QAsView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports